module.exports = __webpack_public_path__ + "img/questionnaire-yellow.78ec4e20.svg";